import * as React from "react"

// Funcitons
// Internal
import "./_tile-content-reports.scss"

const TileContentReports = ({ reports, ...props }) => {
  const atomClassName = "tile-content-reports"
  const atomClass =
    props?.className !== undefined
      ? atomClassName + " " + props?.className
      : atomClassName

  // Verifica che reports sia un array valido
  const hasReports = Array.isArray(reports) && reports.length > 0;

  return (
    <div className={atomClass} {...props}>
      {hasReports &&
        reports.map((report, index) => (
          <div
            key={"report-" + index}
            className={"element d-flex flex-column gap-2"}
          >
            <div className="d-flex flex-column gap-1">
              <p className="fs-12 m-0">{report?.year || ''}</p>
              <p className="fs-24 m-0">{report?.amountTitle || ''}</p>
              <p className="fs-12 caption m-0 mt-1">{report?.caption || ''}</p>
            </div>
          </div>
        ))}
    </div>
  )
}

export default TileContentReports
